import { render, staticRenderFns } from "./ResellerSRA.vue?vue&type=template&id=7634f2e8&scoped=true&"
import script from "./ResellerSRA.vue?vue&type=script&lang=js&"
export * from "./ResellerSRA.vue?vue&type=script&lang=js&"
import style0 from "./ResellerSRA.vue?vue&type=style&index=0&id=7634f2e8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7634f2e8",
  null
  
)

export default component.exports